import moment from 'moment';

export default function GREditReportStatusDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  confirmDialog,
  ssDialogService,
  loaderService,
  reportsDataService,
) {
  const vm = this;

  vm.completedById = -1;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSubmit = handleSubmit;

  vm.IsValidControl = _IsValidControl;

  _activate();

  function _activate() {
    vm.acknowledgeStatusId = 3;

    vm.reviewMinDate = moment().add(-18, 'months');
    vm.reviewCurrentDate = moment().add(0, 'days');
    vm.reviewMaxDate = vm.reviewCurrentDate;
    vm.reviewDate = vm.reviewCurrentDate.format('MM/DD/YYYY');
  }

  /** ********************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleSubmit() {
    if ($scope.srEditReportStatusForm.$valid) {
      const dfdSave = $q.defer();
      loaderService.showViewLoader = true;
      if ($scope.srEditReportStatusForm.$valid) {
        vm.reviewDate = vm.reviewCurrentDate.format('MM/DD/YYYY');

        reportsDataService.saveAcknowledgeStatus(
          vm.reportInstance.reportInstanceId,
          vm.acknowledgeStatusId,
          vm.completedById,
          vm.reviewDate,
          vm.reportStatusText,
        ).then((response) => {
          if (!response.data) {
            alerts.error('Error occurred while marking the Report as Reviewed.');
          } else {
            vm.reportInstanceComment = response.data;
            alerts.success('The Report has been successfully marked as Reviewed.');
            const reportInstanceId = vm.reportInstance.reportInstanceId;
            $rootScope.$broadcast('refreshReportStatus', { reportInstanceId });
            ssDialogService.hide(ssDialogService.dialogs.reports.editReportStatusDialog);
            loaderService.showViewLoader = false;
          }
          dfdSave.resolve();
        });
      } else {
        dfdSave.reject();
      }
    }
  }

  /** ********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.reports.editReportStatusDialog);
  }

  function _IsValidControl(ctrl) {
    return ($scope.srEditReportStatusForm)
      && (($scope.srEditReportStatusForm.$submitted && ctrl.$invalid) || (ctrl.$dirty && ctrl.$invalid));
  }
}

GREditReportStatusDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'confirmDialog',
  'ssDialogService',
  'loaderService',
  'reportsDataService',
];
